

const arg = (x) => x
const compose = (next, func) => inputArg => next(func(inputArg))  
export const composeFunctions = (...all) => all.reduce(compose, arg);
